module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 89.8240394a.png";